import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { putApi } from '../../apiUtils';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import { AttachmentCategoriesForm } from '../../forms/attachmentCategories/AttachmentCategoriesForm';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { AttachmentCategory, AttachmentCategoryInputs } from '../../types/attachmentCategory.types';
import { DetailPageParams } from '../../types/pageParams.types';
import { API_URL, fetcher } from '../../utils/apiUrl';

export function AttachmentCategoriesEdit() {
  const { translate } = useTranslation();
  const transFormName = 'AttachmentCategory.Update';
  const { startLoading, stopLoading } = useLoading();
  const { id } = useParams<DetailPageParams>();
  const { data, error } = useSWR<AttachmentCategory>(
    `${API_URL.ATTACHMENT_CATEGORY_ITEM}?id=${id}`,
    fetcher,
  );
  const [formData, setFormData] = useState<AttachmentCategoryInputs>();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'Edit attachment category',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'Attachment categories', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  useEffect(() => {
    if (!data) return;
    setFormData({ ...data });
  }, [data]);

  const onSubmit = async (e) => {
    if (e !== null) e.preventDefault();
    if (!data) return;

    let isOk = false;
    startLoading();
    await putApi({
      url: API_URL.ATTACHMENT_CATEGORY_PUT,
      data: formData,
      callAfterSuccess: () => {
        isOk = true;
      },
    });
    stopLoading();
    return isOk;
  };

  return (
    <PageContentWrapper
      heading={translate!('Edit attachment category', transFormName)}
      error={error}
    >
      {/* entita je součástí unikátního klíče, BE její změnu odmítá */}
      <AttachmentCategoriesForm onSubmit={onSubmit} formData={formData} isEdit disableEntity />
    </PageContentWrapper>
  );
}

export default AttachmentCategoriesEdit;
